import { GridCellProps } from '@progress/kendo-react-grid';
import styled from 'styled-components';
import { capitalizeFirstLetter } from 'utils/common';

type Props = {
    className?: string;
    e: GridCellProps;
    onClick?: (e) => void;
    type: "type" | "paymentStatus";
};

const StyledBadge = styled.div<{ $value: string; $isUnpaid: boolean }>`
  display: flex;
  gap: 6px;
  padding: 2px 12px;
  border-radius: 100px;
  align-items: center;
  width: fit-content;
  .value-style{
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    text-transform: capitalize;
  }
  
  ${({ $value }) => {
        switch ($value) {
            case "paid":
            case "team":
                return `
          color: #10b981;
          background-color: rgba(16, 185, 129, 0.1);
        `;
            case "unpaid":
                return `
          color: #ef4444;
          background-color: rgba(239, 68, 68, 0.1);
        `;
            case "rider":
                return `
          color: #F59E0B;
          background-color: #F59E0B20;
        `;
            case "coach":
                return `
          color: #3B82F6;
          background-color: #3B82F620;
        `;
            default:
                return `
          color: #6b7280;
          background-color: rgba(107, 114, 128, 0.1);
        `;
        }
    }}
  
  ${({ $isUnpaid }) => $isUnpaid && `
    padding-top: 4px;
    padding-bottom: 4px;
  `}
`;

const IconImage = styled.img<{ $isPaid: boolean }>`
  object-fit: contain;
  flex-shrink: 0;
  width: ${({ $isPaid }) => $isPaid ? '9px' : '10px'};
  aspect-ratio: ${({ $isPaid }) => $isPaid ? '1.33' : '1'};
  ${({ $isPaid }) => $isPaid ? 'margin: auto 0;' : 'align-self: center;'}
`;

const StatusBadgeCell = ({ className, e, onClick, type }: Props) => {
    const data = type === "type" ? e.dataItem?.type : e.dataItem?.paymentStatus;
    const value = data === true ? 'paid' : data === false ? 'unpaid' : data.toLocaleLowerCase();
    console.log(value, 'value')
    const getPaymentIcon = (value: string) => {
        if (value === "paid") {
            return (
                <IconImage
                    $isPaid={true}
                    src="https://api.builder.io/api/v1/image/assets/TEMP/b3acc9a1cc280febb2f315459afce3b8186f8d43?placeholderIfAbsent=true&apiKey=b05e8d652feb4bba8436163fdc40ce87"
                    alt=""
                />
            );
        } else if (value === "unpaid") {
            return (
                <IconImage
                    $isPaid={false}
                    src="https://api.builder.io/api/v1/image/assets/TEMP/55d6dd5668ddb3ae5c08b8a2aab250870516f2f2?placeholderIfAbsent=true&apiKey=b05e8d652feb4bba8436163fdc40ce87"
                    alt=""
                />
            );
        }
        return null;
    };

    return (
        <td className={className ?? ''} onClick={onClick}>
            <StyledBadge $value={value} $isUnpaid={value === "unpaid"}>
                {type !== "type" && getPaymentIcon(value)}
                <div className='value-style'>{capitalizeFirstLetter(value)}</div>
            </StyledBadge>
        </td>
    );
};

export default StatusBadgeCell;